import SEO from "../components/SEO";
import LeadForm from "../components/forms/LeadForm";
import { Phone, Mail, Clock, Shield } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/site";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Pennsylvania Accident Aid | Free 24/7 Case Review"
        description="Get a free, confidential case review from a Pennsylvania accident attorney. Available 24/7. No fees unless you win."
      />
      <section className="pt-12 md:pt-20 pb-16 md:pb-24 px-6 bg-bone">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6">
            <div className="overline mb-3">Free Case Review</div>
            <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-6 text-balance">
              Tell us what happened. We'll take it from there.
            </h1>
            <p className="text-lg text-charcoal-soft leading-relaxed mb-10">
              Fill out the form, or call us directly. A Pennsylvania attorney will reach out to you within minutes.
              100% free. 100% confidential. No fees unless you win.
            </p>

            <div className="space-y-4 mb-10">
              <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-4 p-4 rounded-xl border border-black/5 bg-white hover:border-terracotta hover:shadow-md transition-all" data-testid="contact-phone-card">
                <div className="w-12 h-12 rounded-full bg-terracotta text-white grid place-items-center"><Phone className="w-5 h-5" /></div>
                <div>
                  <div className="font-display font-bold text-forest">Call us 24/7</div>
                  <div className="text-2xl font-display font-black text-terracotta">{PHONE_DISPLAY}</div>
                </div>
              </a>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <Trust icon={Clock} title="24/7" sub="Always available" />
              <Trust icon={Shield} title="100%" sub="Confidential" />
            </div>
          </div>

          <div className="lg:col-span-6 lg:sticky lg:top-24">
            <LeadForm sourcePage="contact" />
          </div>
        </div>
      </section>
    </>
  );
}

function Trust({ icon: Icon, title, sub }) {
  return (
    <div className="flex items-start gap-3 p-4 rounded-xl bg-bone-alt">
      <div className="w-9 h-9 rounded-full bg-forest text-bone grid place-items-center shrink-0">
        <Icon className="w-4 h-4" />
      </div>
      <div className="leading-tight">
        <div className="font-display font-bold text-forest text-lg">{title}</div>
        <div className="text-xs text-charcoal-soft">{sub}</div>
      </div>
    </div>
  );
}
